import { makeStyles } from '@mui/styles'
import { PiStethoscopeDuotone } from 'react-icons/pi'
import { FaPersonCircleCheck } from 'react-icons/fa6'
import { format } from 'date-fns'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: '100%',
    fontSize: '1.0rem',
    borderTop: '1px solid #CBCBCB',
    borderRight: '1px solid #CBCBCB',
    borderBottom: '1px solid #CBCBCB',
    padding: '10px',
    borderLeftWidth: '10px',
    borderLeftStyle: 'solid',
    borderRadius: '3px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#ebebeb',
      transition: 'all 0.3s ease',
      opacity: '0.8',
    },
  },
}))
const returnColor = (tpEstado) => {
  switch (tpEstado) {
    case '3':
      return '#d91414'
    case '5':
      return '#757575'
    case '6':
      return '#f9f9f9'
    default:
      return '#757575'
  }
}

const returnFontColor = (tpEstado) => {
  switch (tpEstado) {
    case '6':
      return '#999'
    default:
      return 'white'
  }
}

export const ItemAtendimento = ({ atendimento, listaHistoricoPaciente }) => {
  const classes = useStyles(atendimento)

  const handleClickAtendimento = () => {
    listaHistoricoPaciente(atendimento, true)
  }

  return (
    <div
      onClick={() => handleClickAtendimento()}
      className={`${classes.container} ${atendimento ? '' : 'placeholder-class'}`}
      style={{ borderLeftColor: returnColor(atendimento?.[5]?.tpEstado) }}
    >
      <div style={{ width: '5%' }}>
        <p style={{ margin: 0 }}>
          {atendimento[1] ? format(new Date(atendimento[1]), 'HH:mm') : null}
        </p>
      </div>
      <div style={{ width: '65%' }}>
        <p style={{ fontWeight: '700', margin: 0 }}>{atendimento?.[3]}</p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '20%',
          fontSize: 14,
          color: 'white',
          padding: '7px',
          borderRadius: '20px',
          backgroundColor: returnColor(atendimento?.[5]?.tpEstado),
        }}
      >
        {atendimento?.[5]?.tpEstado === '3' && <PiStethoscopeDuotone />}
        {atendimento?.[5]?.tpEstado === '6' && (
          <FaPersonCircleCheck style={{ color: '#999' }} />
        )}
        <p
          style={{
            margin: 0,
            marginLeft: '10px',
            color: returnFontColor(atendimento?.[5]?.tpEstado),
          }}
        >
          {atendimento?.[5]?.dsEstado}
        </p>
      </div>
    </div>
  )
}
